/* ============================================================
   PW Design System — comportamiento
   Interruptor de tema + transiciones magneticas.
   Se carga con defer: nada de esto es critico para el primer pintado
   (de eso ya se encarga pw-tema.js).
   ============================================================ */
if (!window.pwDsCargado) {
  window.pwDsCargado = true;

  var pwMqOscuro = window.matchMedia('(prefers-color-scheme: dark)');
  var pwMqHover = window.matchMedia('(hover: hover)');
  var pwMqQuieto = window.matchMedia('(prefers-reduced-motion: reduce)');

  function pwAplicarTema(t, manual) {
    var h = document.documentElement;
    h.setAttribute('data-pw-tema', t);
    h.classList.toggle('pw-oscuro', t === 'oscuro');
    if (manual) {
      h.removeAttribute('data-pw-auto');
      try { localStorage.setItem('pw-tema', t); } catch (e) {}
    }
    document.querySelectorAll('[data-pw-tema-btn]').forEach(function (b) {
      b.setAttribute('aria-pressed', t === 'oscuro' ? 'true' : 'false');
    });
  }

  function pwInitTema() {
    document.querySelectorAll('[data-pw-tema-btn]').forEach(function (b) {
      if (b.dataset.pwListo) return;
      b.dataset.pwListo = '1';
      b.setAttribute('aria-pressed', document.documentElement.classList.contains('pw-oscuro') ? 'true' : 'false');
      b.addEventListener('click', function () {
        pwAplicarTema(document.documentElement.getAttribute('data-pw-tema') === 'oscuro' ? 'claro' : 'oscuro', true);
      });
    });
  }

  /* Mientras no haya elegido a mano, la tienda sigue al sistema en
     caliente: si cambia el modo del movil, cambia la pagina sin recargar. */
  function pwSeguirSistema(e) {
    if (document.documentElement.getAttribute('data-pw-auto') !== '1') return;
    pwAplicarTema(e.matches ? 'oscuro' : 'claro', false);
  }
  if (pwMqOscuro.addEventListener) pwMqOscuro.addEventListener('change', pwSeguirSistema);
  else if (pwMqOscuro.addListener) pwMqOscuro.addListener(pwSeguirSistema);

  /* ---- Iman ----
     El elemento se desplaza hacia el cursor, como maximo data-iman px,
     y solo dentro de un margen de 24px alrededor. El movimiento se
     escribe en variables CSS para que la transicion la siga mandando
     el CSS y no pelearse con el transform de otros efectos. */
  function pwInitIman() {
    if (!pwMqHover.matches || pwMqQuieto.matches) return;
    document.querySelectorAll('.pw-iman').forEach(function (el) {
      if (el.dataset.pwIman) return;
      el.dataset.pwIman = '1';
      var max = parseFloat(el.getAttribute('data-iman')) || 6;
      var margen = 24;

      el.addEventListener('pointermove', function (e) {
        var r = el.getBoundingClientRect();
        var dx = (e.clientX - (r.left + r.width / 2)) / (r.width / 2 + margen);
        var dy = (e.clientY - (r.top + r.height / 2)) / (r.height / 2 + margen);
        el.classList.add('pw-iman--activo');
        el.style.setProperty('--pw-im-x', (Math.max(-1, Math.min(1, dx)) * max).toFixed(1) + 'px');
        el.style.setProperty('--pw-im-y', (Math.max(-1, Math.min(1, dy)) * max).toFixed(1) + 'px');
      });

      el.addEventListener('pointerleave', function () {
        el.style.setProperty('--pw-im-x', '0px');
        el.style.setProperty('--pw-im-y', '0px');
        /* La clase se retira cuando la transicion ha vuelto a cero, no
           antes: si se quita de golpe, el elemento salta a su sitio. */
        setTimeout(function () { el.classList.remove('pw-iman--activo'); }, 260);
      });
    });
  }

  function pwDsArrancar() { pwInitTema(); pwInitIman(); }
  pwDsArrancar();
  document.addEventListener('DOMContentLoaded', pwDsArrancar);
  document.addEventListener('shopify:section:load', pwDsArrancar);
}
